import {useEffect, useState} from 'react';

const QUERY = '(max-width: 900px)';

/**
 * True on phones and small tablets, where the swap table is replaced by a card
 * list instead of asking the operator to scroll a ten-column grid sideways.
 */
const useIsCompact = () => {
  const [isCompact, setIsCompact] = useState(
    () =>
      typeof window !== 'undefined' &&
      !!window.matchMedia &&
      window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const media = window.matchMedia(QUERY);
    const handleChange = event => setIsCompact(event.matches);
    handleChange(media);

    if (media.addEventListener) {
      media.addEventListener('change', handleChange);
      return () => media.removeEventListener('change', handleChange);
    }
    media.addListener(handleChange);
    return () => media.removeListener(handleChange);
  }, []);

  return isCompact;
};

export default useIsCompact;
